import SuccessMessage from './SuccessMessage.vue';

export default SuccessMessage;



// WEBPACK FOOTER //
// ./src/pages/vacancies/form/components/successmewssage/index.ts